{
  "generic": {
    "no": "Nej",
    "yes": "Ja",
    "text": "Tekst "
  },
  "consent": {
    "defaultLabelText": "Jeg accepterer vilkårene og betingelserne",
    "defaultLabelLink": "Fortrolighedspolitik"
  },
  "text": {
    "defaultHeadlineText": "Dette er en overskrift",
    "defaultText": "Dette er en tekstblok",
    "floatingDefaultText": "NYT!"
  },
  "button": {
    "submitDefaultText": "Indsend",
    "instagramDefaultText": "Følg os",
    "defaultText": "Klik her",
    "closing": "LUKKER..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Indtast din e-mail",
    "passwordLabel": "Adgangskode",
    "passwordPlaceholder": "Indtast adgangskode",
    "nameLabel": "Navn",
    "namePlaceholder": "Indtast dit navn",
    "firstNameLabel": "Fornavn",
    "firstNamePlaceholder": "Indtast fornavn",
    "lastNameLabel": "Efternavn",
    "lastNamePlaceholder": "Indtast efternavn",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Indtast telefonnummer",
    "textareaLabel": "Besked",
    "textareaPlaceholder": "Indtast din besked",
    "regularLabel": "Tekst",
    "regularPlaceholder": "Indtast tekst",
    "defaultLabel": "Etiket",
    "defaultPlaceholder": "Pladsholder",
    "datePlaceholder": "Vælg dato",
    "stepLabel": "Indtast dit spørgsmål her"
  },
  "dropdown": {
    "placeholder": "Vælg en mulighed",
    "firstItem": "Mulighed 1",
    "secondItem": "Mulighed 2",
    "chooseCountry": "Land"
  },
  "buttonList": {
    "firstItem": "Mulighed 1",
    "secondItem": "Mulighed 2",
    "option1": "Valg 1",
    "option2": "Valg 2",
    "option3": "Valg 3",
    "subscriptionItem1": "Nyhedsbrev",
    "subscriptionItem2": "Opdateringer",
    "chooseSubscriptionTopics": "Vælg abonnementsemner",
    "other": "Andet",
    "uncheck-all-label": "Jeg ønsker ikke at modtage nogen af disse e-mails"
  },
  "rating": {
    "rateLabel": "Bedøm os",
    "npsLabel": "Hvor sandsynligt er det, at du vil anbefale os?",
    "veryUnsatisfied": "Meget utilfreds",
    "unsatisfied": "Utilfreds",
    "neutral": "Neutral",
    "satisfied": "Tilfreds",
    "loveIt": "Elsker det!",
    "minValueLabel": "Lav",
    "maxValueLabel": "Høj",
    "minValueLabelNps": "Ikke sandsynligt",
    "maxValueLabelNps": "Meget sandsynligt"
  },
  "deadline": {
    "days": "Dage",
    "hours": "Timer",
    "minutes": "Minutter",
    "seconds": "Sekunder"
  },
  "bulletList": {
    "firstItem": "Fordel 1",
    "secondItem": "Fordel 2"
  },
  "discountCode": {
    "copyMessage": "Kopieret til udklipsholder!",
    "fallback": "WELCOME10",
    "textDefault": "Din rabatkode",
    "buttonDefault": "Kopier"
  },
  "share": {
    "buttonText": "Del"
  },
  "common": {
    "label": "Etiket"
  },
  "wcag": {
    "banner": "Reklamebanner",
    "closeButton": "Luk",
    "submitButton": "Indsend formular"
  },
  "spinTheWheel": {
    "prizeWonText": "Tillykke!",
    "prizeWonButtonText": "Kræv din præmie",
    "prizeLostText": "Åh nej, det var for dårligt! :-(",
    "prizeLostButtonText": "Klik for at lukke",
    "spinButtonLabel": "DREJ"
  },
  "memory": {
    "resultWonText": "Godt klaret! Din tid var {elapsedTime}",
    "resultWonButtonText": "Kræv din præmie"
  },
  "stepNavigation": {
    "nextButtonText": "Næste",
    "previousButtonText": "Tilbage",
    "lastButtonText": "Luk",
    "submitButtonText": "Indsend"
  },
  "defaultRealTimeMessage": {
    "validationError": "Tjek venligst formatet på de data, du har sendt.",
    "unknownError": "Der opstod et uventet problem ved indsendelse.",
    "conflictError": "Denne bruger eksisterer allerede.",
    "success": "Formular indsendt."
  }
}
